import React from 'react';
import { Navigate } from 'react-router-dom';

const AdminRoute = ({ children }) => {
    const token = localStorage.getItem('adminToken');
    const adminData = localStorage.getItem('adminData');

    if (!token || !adminData) {
        return <Navigate to="/admin/login" />;
    }

    try {
        const parsedAdmin = JSON.parse(adminData);
        // Ajuste para aceitar 'superadmin' que é o role definido no login
        if (parsedAdmin.username !== 'supportAdmin' || parsedAdmin.role !== 'superadmin') {
            return <Navigate to="/admin/login" />;
        }
    } catch (error) {
        // Em caso de erro na análise do JSON, redireciona para o login
        console.error('Erro ao verificar dados do admin:', error);
        return <Navigate to="/admin/login" />;
    }

    return children;
};

export default AdminRoute;
